import { Injectable } from '@angular/core';
import { OrderAnalyticsService } from '@order/tracking/analytics/order-analytics.service';
import { SelectedCustomerState, Tracking } from '@panamax/app-state';
import { OrderItem } from '@usf/ngrx-order';

@Injectable({
  providedIn: 'root',
})
export class AddToOrderService {
  static createAnalytics(
    action: any,
    successAction: any,
    customer: SelectedCustomerState,
    productMap: any,
  ): Tracking {
    return {
      ...action.trackingAnalytics,
      analytics: {
        ...action.trackingAnalytics.analytics,
        data: {
          ...action.trackingAnalytics.analytics.data,
          order: {
            id: OrderAnalyticsService.getAnalyticsOrderId(
              successAction?.orderHeader,
            ),
          },
          products: AddToOrderService.productsAnalytics(
            customer,
            action.updateOrderItemSequence,
            productMap,
            action.trackingAnalytics,
          ),
        },
      },
    };
  }

  static productsAnalytics(
    customer: SelectedCustomerState,
    updateOrderItem: OrderItem,
    productMap: any,
    trackingData: Tracking,
  ): {
    divisionApn: string;
    quantityUnits: string;
    quantity: number;
    attributes: string;
  }[] {
    // Make sure that products exist in the tracking data
    const products: any = trackingData.analytics?.data?.products;
    if (!products || products.length === 0) return [];

    // Split the first product from the rest
    const [firstProduct, ...remainingProducts] = products;

    // Return a new array, where the first item is a transformed product and the rest are unaltered
    return [
      {
        ...firstProduct,
        divisionApn:
          customer.divisionNumber + '-' + updateOrderItem.productNumber,
        quantityUnits: AddToOrderService.quantityChangeType(updateOrderItem),
        quantity: AddToOrderService.quantity(updateOrderItem),
        attributes: productMap.get(updateOrderItem.productNumber)
          ?.trackingAttributes,
      },
      ...remainingProducts,
    ];
  }

  static isQuantityIncreasing(updateOrderItem: OrderItem): boolean {
    return (
      AddToOrderService.isUnitsIncreasing(updateOrderItem) ||
      AddToOrderService.isEachesIncreasing(updateOrderItem)
    );
  }

  static isEachesIncreasing(updateOrderItem: OrderItem): boolean {
    const currentEaches = updateOrderItem.eachesOrdered?.currentValue || 0;
    const previousEaches = updateOrderItem.eachesOrdered?.previousValue || 0;
    return currentEaches > previousEaches;
  }

  static isUnitsIncreasing(updateOrderItem: OrderItem): boolean {
    const currentUnits = updateOrderItem.unitsOrdered?.currentValue || 0;
    const previousUnits = updateOrderItem.unitsOrdered?.previousValue || 0;
    return currentUnits > previousUnits;
  }

  static quantityChangeType(updateOrderItem: OrderItem): string {
    return AddToOrderService.isUnitsIncreasing(updateOrderItem) ? 'CS' : 'EA';
  }

  static quantity(updateOrderItem: OrderItem): number {
    return AddToOrderService.isUnitsIncreasing(updateOrderItem)
      ? updateOrderItem.unitsOrdered.currentValue -
          (updateOrderItem.unitsOrdered.previousValue || 0)
      : updateOrderItem.eachesOrdered.currentValue -
          (updateOrderItem.eachesOrdered.previousValue || 0);
  }
}
